import axios from "axios";

let Api = axios.create({
    baseURL: process.env.VUE_APP_API_URL+"/api/"
});

Api.defaults.withCredentials = true;
Api.defaults.withXSRFToken = true;

export default Api;